class EmergencyProperty {
  constructor({
    id = null,
    name,
    contact,
    address,
    urgencyLevel,
    propertyType,
    createdAt = null,
    updatedAt = null,
  }) {
    this.id = id;
    this.name = name;
    this.contact = contact;
    this.address = address;
    this.urgencyLevel = urgencyLevel;
    this.propertyType = propertyType;
    this.createdAt = createdAt || new Date();
    this.updatedAt = updatedAt || new Date();
  }

  // Convert to object for Firestore
  toObject() {
    return {
      name: this.name,
      contact: this.contact,
      address: this.address,
      urgencyLevel: this.urgencyLevel,
      propertyType: this.propertyType,
      createdAt: this.createdAt,
      updatedAt: new Date(),
    };
  }

  // Create from Firestore document
  static fromFirestore(doc) {
    const data = doc.data();
    return new EmergencyProperty({
      id: doc.id,
      name: data.name || "",
      contact: data.contact || "",
      address: data.address || "",
      urgencyLevel: data.urgencyLevel || "",
      propertyType: data.propertyType || "",
      createdAt: data.createdAt?.toDate() || null,
      updatedAt: data.updatedAt?.toDate() || null,
    });
  }

  // Copy with method for updates
  copyWith(updates) {
    return new EmergencyProperty({
      id: this.id,
      name: updates.name ?? this.name,
      contact: updates.contact ?? this.contact,
      address: updates.address ?? this.address,
      urgencyLevel: updates.urgencyLevel ?? this.urgencyLevel,
      propertyType: updates.propertyType ?? this.propertyType,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
    });
  }
}

export default EmergencyProperty;
